"use client";

import { trackEvent } from "./track-event";

interface NavigationTrackingProps {
	action: string;
	category?: string;
	matomo?: {
		category: string;
		action: string;
	};
}

/**
 * Track navigation events like nav-whatsapp, nav-call, nav-blog, etc.
 * Based on events from i/webapp/app/Links.js
 */
export function trackNavItem({ action, category, matomo }: NavigationTrackingProps) {
	const eventName = `nav-${action}`;

	// Default matomo tracking for navigation events
	const defaultMatomoEvent = `click on ${action}`;
	const defaultMatomoCategory = "navigation";

	trackEvent({
		google: {
			event: eventName,
			options: {
				event_category: category || "navigation",
				event_label: action,
			},
		},
		matomo: matomo
			? {
					event: matomo.action,
					options: {
						category: matomo.category,
					},
				}
			: {
					event: defaultMatomoEvent,
					options: {
						category: defaultMatomoCategory,
					},
				},
	});
}
